import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ds-segmented-picker bonusomat-board-filter" }
const _hoisted_2 = { class: "ds-segmented-picker__nav is-dark" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["data-title"]
const _hoisted_5 = { class: "ds-segmented-picker__text-inner" }

import { computed } from "vue";
import { BonusomatDatalayer } from "@/casino/bonusomat/utils/analytics/bonusomat-datalayer";
import { BonusomatFilterValues, BoardFilterOption } from "../../models/bonusomat-board-filter";
import { useLoyaltyPlayerStatus } from "@/loyalty/composables/use-loyalty-player-status";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-board-filter',
  props: {
    modelValue: {},
    options: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { bonusomatPlayerStatus } = useLoyaltyPlayerStatus();
const { bonusomatPlayerData, remainingSpinsCount } = bonusomatPlayerStatus;

const getAnalyticsFilterItemLabel = (filterValue: string) => {
    switch (filterValue) {
        case "":
            return "Vše";
        case "uncompleted":
            return "Nesplněné";
        case "completed":
            return "Splněné";
        case "repeating":
            return "Opakující se";
        default:
            return "Unknown";
    }
};

const selectedValue = computed({
    get() {
        return props.modelValue;
    },
    set(newValue) {
        if (props.modelValue === newValue) {
            emit("update:modelValue", BonusomatFilterValues.All);
        } else {
            emit("update:modelValue", newValue);
        }
        BonusomatDatalayer.pushBoardFilterItemClick(
            getAnalyticsFilterItemLabel(newValue),
            bonusomatPlayerData.value.points,
            remainingSpinsCount.value
        );
    },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item, index) => {
        return (_openBlock(), _createElementBlock("button", {
          class: _normalizeClass(["ds-segmented-picker__toggle is-dark", { 'is-active ': selectedValue.value === item.value }]),
          key: index,
          onClick: ($event: any) => (selectedValue.value = item.value)
        }, [
          _createElementVNode("span", {
            class: "ds-segmented-picker__text",
            "data-title": item.text
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(item.text), 1)
          ], 8, _hoisted_4)
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})